import { computeForMonth } from "@vulpari/core";
import { useState } from "react";

import { downloadFile, graphToJson, movesToCsv } from "../lib/export.js";
import { useStore } from "../store.js";
import { Icon } from "./Icon.js";

export function ExportMenu() {
  const nodes = useStore((state) => state.nodes);
  const flows = useStore((state) => state.flows);
  const context = useStore((state) => state.context);
  const ledgers = useStore((state) => state.ledgers);
  const currentLedgerId = useStore((state) => state.currentLedgerId);

  const [open, setOpen] = useState(false);

  const ledger = ledgers.find((l) => l.id === currentLedgerId);
  const slug = (ledger?.name ?? "ledger")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

  function exportJson() {
    downloadFile(`vulpari-${slug}.json`, graphToJson(nodes, flows), "application/json");
    setOpen(false);
  }

  function exportCsv() {
    const primaryCurrency = context.primaryCurrency ?? "GBP";
    const { result } = computeForMonth({
      nodes,
      flows,
      startMonth: ledger?.startMonth ?? context.month,
      month: context.month,
      primaryCurrency,
      rates: context.rates,
    });
    downloadFile(
      `vulpari-${slug}-${context.month}-moves.csv`,
      movesToCsv(result.moves, nodes, {
        month: context.month,
        primaryCurrency,
        rates: context.rates,
      }),
      "text/csv",
    );
    setOpen(false);
  }

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="flex items-center gap-1.5 rounded-lg border border-node-border px-3 py-1.5 text-sm text-ink-muted hover:text-ink"
      >
        <Icon name="download" size={16} />
        Export
      </button>

      {open ? (
        <>
          <button
            type="button"
            aria-hidden
            tabIndex={-1}
            className="fixed inset-0 z-10 cursor-default"
            onClick={() => setOpen(false)}
          />
          <div className="absolute right-0 z-20 mt-1 w-48 overflow-hidden rounded-lg border border-node-border bg-node-bg shadow-xl">
            <button
              type="button"
              onClick={exportJson}
              className="block w-full px-3 py-2 text-left text-sm text-ink hover:bg-canvas"
            >
              Graph (JSON)
            </button>
            <button
              type="button"
              onClick={exportCsv}
              className="block w-full px-3 py-2 text-left text-sm text-ink hover:bg-canvas"
            >
              Payday moves (CSV)
            </button>
          </div>
        </>
      ) : null}
    </div>
  );
}
